<template>
  <v-app app>
    <global-events
      @keyup.ctrl.left="rdrawer = isRTL"
      @keyup.ctrl.right="rdrawer = !isRTL"
      @keyup.alt.up="$router.push('/daily-transactions/credits')"
      @keyup.alt.down="$router.push('/daily-transactions/debits')"
      @keyup.alt.right="$router.push('/daily-transactions/exchanges')"
      @keyup.alt.left="$router.push('/daily-transactions/a2a-transfers')"
      @keyup.alt.t="$router.push('/daily-transactions/send-transfers')"
      @keyup.alt.r="$router.push('/daily-transactions/receive-transfers')"
      @keyup.ctrl.alt.d="$router.push('/')"
      @keyup.ctrl.alt.49="$router.push('/reports')"
      @keyup.ctrl.alt.50="$router.push('/lctr-report')"
      @keyup.ctrl.alt.51="$router.push('/income-statement')"
      @keyup.ctrl.alt.52="$router.push('/balance-sheet')"
      @keyup.ctrl.alt.53="$router.push('/transactions-report')"
      @keyup.ctrl.alt.54="$router.push('/individuals-kyc-report?kyc=true')"
      @keyup.ctrl.alt.55="$router.push('/corporates-kyc-report?kyc=true')"
      @keyup.ctrl.space="searchDialog = !searchDialog"
      @keyup.ctrl.shift.s="shortcutDialog = !shortcutDialog"
    />
    <s-toolbar :rdrawer.sync="rdrawer" :ldrawer.sync="ldrawer" />
    <r-sidebar :appDrawer.sync="rdrawer" />
    <l-sidebar :appDrawer.sync="ldrawer" />

    <v-content class="grey8">
      <v-slide-x-transition mode="out-in">
        <router-view />
      </v-slide-x-transition>
    </v-content>

    <v-snackbar
      top
      right
      class="mt-2"
      :timeout="7000"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      <span>{{ snackbar.text }}</span>
      <v-btn icon class="px-1" @click="closeSnackbar" flat>
        <v-icon class="grey--text text--darken-3">cancel</v-icon>
      </v-btn>
    </v-snackbar>
    <search-dialog v-model="searchDialog" width="1000px" />
    <shortcut-dialog v-model="shortcutDialog" width="1000px" />
  </v-app>
</template> 
<script>
import { customersMixin } from "@/mixins/index.js";
import RSidebar from "../../components/RSidebar2.vue";
import LSidebar from "../../components/LSidebar2.vue";
import SToolbar from "../../components/SToolbar.vue";
import GlobalEvents from "vue-global-events";
import { mapGetters } from "vuex";

export default {
  mixins: [customersMixin],
  name: "Index",
  components: {
    GlobalEvents,
    RSidebar,
    LSidebar,
    SToolbar,
  },
  data: () => ({
    rdrawer: true,
    ldrawer: false,
    searchDialog: false,
    shortcutDialog: false,
  }),

  computed: {
    ...mapGetters({ snackbar: "globalSnackbar" }),
    crumbs() {
      return this.$breadcrumbs;
    },
    isRTL(){
      return this.$vuetify.rtl
    }
  },

  methods: {
    closeSnackbar() {
      this.$store.commit("showSnackbar", {
        stateType: "",
        show: false,
        text: "",
      });
    },
  },

  mounted() {
    this.getCustomers();
  },
};
</script>